// extracted by mini-css-extract-plugin
export default {"iconColor":"#44cc94","column":"column__3DRgA","content":"content__3W4ms","headerTitle":"headerTitle__356lU","iconContainer":"iconContainer__1jSJx","headerContainer":"headerContainer__1xk9i","subHeaderContainer":"subHeaderContainer__24jOw","confrimationInfosReminder":"confrimationInfosReminder__3tB_y","title":"title__2GUKH","questionButton":"questionButton__Ss8ng"};
    if(module.hot) {
      // 1778491663487
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  